import { render, staticRenderFns } from "./PqrEdit.vue?vue&type=template&id=5b719890"
import script from "./PqrEdit.vue?vue&type=script&lang=js"
export * from "./PqrEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports